/**
 * 病历模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取病历列表
export const historyList = (params) => {
    return req.get('/order/history/list', params);
}

// 获取病历各状态数量
export const historyNum = (params) => {
    return req.get('/order/history/num', params);
}

// 新增病历
export const historyAdd = (params) => {
    return req.post('/order/history', params);
}

// 快速接诊
export const historyFastAdd = (params, uuid, code) => {
    if (uuid && code) return req.post(`/order/history/fastAdd?uuid=${uuid}&code=${code}`, params);
    else return req.post(`/order/history/fastAdd`, params);
}

// 网诊开方
export const webChatHistoryAdd = (params) => {
    return req.post('/order/history/webchatAdd', params);
}

// 补开处方
export const historyRepair = (params) => {
        return req.post('/order/history/addRecipt', params);
    }
    // 病历完成
export const historyComplete = (orderId) => {
    return req.post(`/order/info/orderComplete?orderId=${orderId}`);
}

// 修改病历信息
export const historyEdit = (params) => {
    return req.put('/order/history', params);
}

// 获取病历详情 -- 线下
export const historyInfo = (orderId) => {
    return req.get(`/order/history/${orderId}`);
}

// 获取病例所有处方
export const historyRecipes = (orderId) => {
    return req.get(`/order/history/recipes?orderId=${orderId}`);
}

// 获取病历详情 -- 网诊
export const historyInfoWebChat = (webChatOrderInfoId) => {
    return req.get(`/order/history/webChatOrder/${webChatOrderInfoId}`);
}

// 获取订单所有划价单和处方列表 订单id
export const orderRecipes = (params) => {
    return req.get('/order/payment/queryOrderPaymentByOrderId', params);
}

// 通过医保支付参数获取所有划价单
export const orderPricing = (params) => {
    return req.get('/order/payment/queryOrderPaymentByMdtrtIdAndSetlId', params);
}

// 获取配方订单列表
export const formulaList = (params) => {
    return req.get('/order/payment/queryOrderRecipePaymentList', params)
}

// 获取中药处方 处方Id
export const recipeDrug = (recipeDrugId) => {
    return req.get(`/recipe/getDrugRecipe/${recipeDrugId}`);
}

// 获取理疗处方 处方Id
export const recipePhysio = (recipePhysioId) => {
    return req.get(`/recipe/getPhysioRecipe/${recipePhysioId}`);
}

// 推送病历下的处方订单
export const orderPush = (params) => {
    return req.post(`/order/info/pushOrder`, params);
}

//  获取订单列表
export const orderList = (params) => {
    return req.get(`/order/info/list`, params);
}

// 获取订单扫码记录
export const scanRecordList = (params) => {
    return req.get(`/order/scan/code/record/list`, params);
}

// 获取同城物流跟踪
export const logisticsTC = (orderPaymentRecipeDrugId, status, params) => {
    return req.get(`/order/scan/code/record/listWechat/${orderPaymentRecipeDrugId}/${status}`, params);
}

// 获取顺丰物流跟踪
export const logisticsSF = (orderNumber) => {
    return req.get(`/sfexpress/order/getRouting/${orderNumber}`);
}

// 删除病历中药处方
export const deleteRecipeDrug = (params) => {
    return req.post(`/recipe/removeDrugRecipe`, params);
}

// 删除病历隐秘处方
export const deleteRecipeCombo = (params) => {
    return req.post(`/recipe/removeComboRecipe`, params);
}

// 删除病历理疗处方
export const deleteRecipePhysio = (params) => {
    return req.post(`/recipe/removePhysioRecipe`, params);
}

//医保诊断
export const meetDiagnose = (params) => {
    return req.get('/yb/diagnose/meetDiagnose', params);
}

//获取处方打印数据 
export const getRecipePrint = (params) => {
    return req.get('/recipe/getRecipePrint', params);
}

//手机上传二维码获取
export const getAppUploadQr = (params) => {
    return req.get(`/order/history/getAppUploadQr`, params);
}

//查询最近病例
export const queryRecentlyCase = (params) => {
    return req.get(`/order/history/queryRecentlyCase`, params);
}

//获取诊前知己内容
export const getDoctorPatientSummary = (params) => {
    return req.get(`/order/history/doctorPatientSummary`, params,'/api',{timeout: 3 * 1000});
}

//更新诊前知己弹出状态
export const updateSummaryFlag = (params) => {
    return req.get(`/order/info/updateSummaryFlag`, params);
}